import { Flex, Text, Tooltip } from '@mantine/core';
import ReactTimeAgo from 'react-time-ago';

const BodyHeader = ({ item }: { item: any }) => {

  const submitter =
    (item?.internalSubmitter || item?.cxSubmitter) ??
    item?.submitter;

  const submitterName = submitter ? submitter?.name || submitter?.displayName : item?.submitterEmail || item?.submitterName; 
  const businessName : string = item?.businessName
  const createdAt = item?.createdAt
  const isMultipleCustomers = item?.isContainer && item?.hasChildren

  return (
    <Flex justify='space-between' h={16}>
      <Flex>
        {businessName && 
        <Tooltip label={businessName.toUpperCase()}>
          <Text px={4} color='#5C5CEB' h='16px' fz='10px' bg='rgba(92, 92, 235, 0.2)' lineClamp={1} sx={{ maxWidth: "100px" }}>
            {businessName.toUpperCase()}
          </Text>
        </Tooltip>}
        {(item?.type !== 'IdeaXConversation') &&
         <Text ml='3px' h='16px' fz='10px'>Submitted by: {isMultipleCustomers? 'Multiple' : (submitterName || 'N/A')}</Text>}
      </Flex>
      

      {createdAt && (
        <Text ml={-4} size="xs" c="dimmed">
          <ReactTimeAgo date={new Date(createdAt)} />
        </Text>
      )}
    </Flex>
  )
}

export default BodyHeader